import "core-js/modules/es6.regexp.match";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es7.string.pad-start";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.array.map";
export function urlSafeEncode(str) {
  return str.split('').map(function (_char) {
    return _char.charCodeAt(0).toString(16).padStart(2, '0');
  }).join('');
}
export function urlSafeDecode(hex) {
  return hex.match(/.{2}/g).map(function (_char2) {
    return String.fromCharCode(parseInt(_char2, 16));
  }).join('');
}